var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#746780",
    d: "M17 6.375v11.25c0 .69-.56 1.25-1.25 1.25h-7.5v1.875h10.625V6.375zM5.125 3.25v14.375h10.626L15.75 3.25zm0-1.25H15.75c.69 0 1.25.56 1.25 1.25v1.875h1.875c.69 0 1.25.56 1.25 1.25V20.75c0 .69-.56 1.25-1.25 1.25H8.25C7.56 22 7 21.44 7 20.75v-1.875H5.125c-.69 0-1.25-.56-1.25-1.25V3.25c0-.69.56-1.25 1.25-1.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default ForwardRef;